module.exports = __webpack_public_path__ + "media/images/os_cara/igor-bc0bdb5b4f5c7d81397f0e8f5a63bdfa.png";